import React from 'react'

import { Image } from 'antd'

import ViewBreakdown from '../modal/ViewBreakdown'

const ScoreCardPlayer = ({ data }) => {
  const { player } = data
  return (
    <div className='sc-player'>
      <div className='top'>
        <div className='left' style={{ flexDirection: 'row' }}>
          <Image
            className='player-img'
            alt='player'
            src={
              player?.player_id?.HostedHeadshotNoBackgroundUrl
                ? player?.player_id?.HostedHeadshotNoBackgroundUrl
                : player?.player_id?.Position === 'G'
                ? require('../../assets/goalie-player.jpeg')
                : require('../../assets/hockey-player.jpeg')
            }
            preview={false}
          />
          <div>
            <p className='name'>{player?.player_id?.Name}</p>
            <p className='position'>
              {player?.player_id?.Position} - {player?.player_id?.Team}
            </p>
          </div>
        </div>
        <p className='score'>{player?.playerScore || '-'}</p>
      </div>
      <div className='bottom'>
        <div>
          <p className='time'>Next Opponent: {player?.player_id?.Opponent || '-'}</p>
          <ViewBreakdown data={player} />
        </div>
      </div>
    </div>
  )
}

export default ScoreCardPlayer
